import { configureStore } from '@reduxjs/toolkit';
import weaknessReducer from './weaknessSlice';
import strengthReducer from './strengthSlice';
import personalReducer from './pesonalValuesSlice';
import motivatesYouReducer from './whatMotivatesYou';
import managerDataSlice from './managerDataSlice';
import userDetails from './userDataSlice';
import discSlice from './DISCSlice';
import setGoalsSlice from './setGoals';
import customizationSlice from './customization';
import organizationReducer from './organizationSlice';
import auditReducer from './auditSlice';
export const store = configureStore({
  reducer: {
    weakness: weaknessReducer,
    strength: strengthReducer,
    personalValues: personalReducer,
    motivatesYou: motivatesYouReducer,
    managerView: managerDataSlice,
    disc: discSlice,
    userData: userDetails,
    setGoals: setGoalsSlice,
    customization: customizationSlice,
    organizationDetails: organizationReducer,
    auditDetails: auditReducer,
  },
});
